var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', {
    staticClass: "wikiContentOverflow"
  }, [_c('div', {
    key: _vm.resetCount,
    ref: "wikiWrap",
    staticClass: "wikiWrap"
  }, [_c('WikiIndex', {
    attrs: {
      "indexList": _vm.titleIndex
    },
    on: {
      "itemSelect": _vm.checkTitlePosition,
      "mounted": function (data) {
        return _vm.bookmarkInfo = data;
      }
    }
  }), _c('div', {
    staticClass: "contentsWrap"
  }, [_vm.isWriter.isWriter ? _c('Writer', {
    attrs: {
      "item": _vm.isWriter
    },
    on: {
      "updated": _vm.getRefs
    }
  }) : _vm._e(), _vm.isProcess.isProcess && _vm.processType == 'NORMAL' ? _c('Process', {
    attrs: {
      "item": _vm.isProcess
    },
    on: {
      "updated": _vm.getRefs
    }
  }) : _vm._e(), _vm.isKeyword.isKeyword ? _c('Keyword', {
    attrs: {
      "item": _vm.isKeyword,
      "editorSelect": _vm.editorSelect,
      "deactivate": _vm.deactivate,
      "readonly": _vm.readonly
    },
    on: {
      "updated": _vm.getRefs
    }
  }) : _vm._e(), _vm._l(_vm.editorList, function (data, index) {
    return _c('WikiContentes', {
      key: index,
      attrs: {
        "editor": data,
        "flip": _vm.flipContent,
        "editorSelect": _vm.editorSelect,
        "active": _vm.activeEdit,
        "deactivate": _vm.deactivate,
        "index": index,
        "save": _vm.saveContent,
        "editable": true,
        "readonly": _vm.readonly
      },
      on: {
        "updated": _vm.getRefs
      }
    });
  })], 2)], 1), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  }), _c('UnitSearch', {
    on: {
      "getUnit": _vm.getProtocolUnit
    }
  }), _c('pdf-wiki')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }